import { useStaticQuery, graphql } from 'gatsby'

export const useSiteMetadata = () => {
  const { site } = useStaticQuery(graphql`
    query {
      site {
        assetPrefix
        siteMetadata {
          url
          baseUrl
          title
          description
          ogTitle
          ogDescription
          banner {
            url
            width
            height
          }
        }
      }
    }
  `)
  return site
}
